import type { PositionAnchor } from "./types";

export const ABOVE_LEFT_ANCHOR: PositionAnchor = {
  x: "left",
  y: "above",
};

export const ABOVE_INNER_LEFT_ANCHOR: PositionAnchor = {
  x: "inner-left",
  y: "above",
};

export const ABOVE_CENTER_ANCHOR: PositionAnchor = {
  x: "center",
  y: "above",
};

export const ABOVE_INNER_RIGHT_ANCHOR: PositionAnchor = {
  x: "inner-right",
  y: "above",
};

export const ABOVE_RIGHT_ANCHOR: PositionAnchor = {
  x: "right",
  y: "above",
};

export const TOP_LEFT_ANCHOR: PositionAnchor = {
  x: "left",
  y: "top",
};

export const TOP_INNER_LEFT_ANCHOR: PositionAnchor = {
  x: "inner-left",
  y: "top",
};

export const TOP_CENTER_ANCHOR: PositionAnchor = {
  x: "center",
  y: "top",
};

export const TOP_INNER_RIGHT_ANCHOR: PositionAnchor = {
  x: "inner-right",
  y: "top",
};

export const TOP_RIGHT_ANCHOR: PositionAnchor = {
  x: "right",
  y: "top",
};

export const CENTER_LEFT_ANCHOR: PositionAnchor = {
  x: "left",
  y: "center",
};

export const CENTER_INNER_LEFT_ANCHOR: PositionAnchor = {
  x: "inner-left",
  y: "center",
};

export const CENTER_CENTER_ANCHOR: PositionAnchor = {
  x: "center",
  y: "center",
};

export const CENTER_INNER_RIGHT_ANCHOR: PositionAnchor = {
  x: "inner-right",
  y: "center",
};

export const CENTER_RIGHT_ANCHOR: PositionAnchor = {
  x: "right",
  y: "center",
};

export const BOTTOM_LEFT_ANCHOR: PositionAnchor = {
  x: "left",
  y: "bottom",
};

export const BOTTOM_INNER_LEFT_ANCHOR: PositionAnchor = {
  x: "inner-left",
  y: "bottom",
};

export const BOTTOM_CENTER_ANCHOR: PositionAnchor = {
  x: "center",
  y: "bottom",
};

export const BOTTOM_INNER_RIGHT_ANCHOR: PositionAnchor = {
  x: "inner-right",
  y: "bottom",
};

export const BOTTOM_RIGHT_ANCHOR: PositionAnchor = {
  x: "right",
  y: "bottom",
};

export const BELOW_LEFT_ANCHOR: PositionAnchor = {
  x: "left",
  y: "below",
};

export const BELOW_INNER_LEFT_ANCHOR: PositionAnchor = {
  x: "inner-left",
  y: "below",
};

export const BELOW_CENTER_ANCHOR: PositionAnchor = {
  x: "center",
  y: "below",
};

export const BELOW_INNER_RIGHT_ANCHOR: PositionAnchor = {
  x: "inner-right",
  y: "below",
};

export const BELOW_RIGHT_ANCHOR: PositionAnchor = {
  x: "right",
  y: "below",
};
